<template>
    <u-card-border-left v-bind="$attrs">
        <txt>
            <template v-for="(_, slotName) in $slots" #[slotName]>
                <slot :name="slotName" />
            </template>
        </txt> 
    </u-card-border-left>
</template>

<script>
import UCardBorderLeft from "@/components/publish/styles/cards/u-card-border-left.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        UCardBorderLeft,
        Txt,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
